import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VotableAnswers from './VotableAnswers';
import VotedAnswers from './VotedAnswers';
import Timestamp from '../../../Timestamp';
import s from './Poll.scss';
const MAX_QUESTION_LENGTH = 55;
const Poll = ({ deviation: { poll }, width, height, className, 'aria-hidden': ariaHidden })=>{
    if (!poll) {
        return null;
    }
    const questionTruncated = poll.question && poll.question.length > MAX_QUESTION_LENGTH ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...` : poll.question;
    return /*#__PURE__*/ React.createElement(Section, {
        style: {
            width,
            height
        },
        className: classnames(className, s['root']),
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: s['question']
    }, questionTruncated), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['date']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: poll.ts
    })), "\xa0 | \xa0", /*#__PURE__*/ React.createElement("span", {
        className: s['vote-count']
    }, poll.votes, " votes")), poll.hasVoted ? /*#__PURE__*/ React.createElement(VotedAnswers, {
        poll: poll
    }) : /*#__PURE__*/ React.createElement(VotableAnswers, {
        poll: poll
    }));
};
export default Poll;
